var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceNo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50241_23394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3512 9.20121V2.71401C10.3512 2.42726 10.2373 2.15225 10.0345 1.94949C9.83175 1.74672 9.55674 1.63281 9.26999 1.63281H2.24219",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39985 11.3636H10.887C11.1738 11.3636 11.4488 11.2497 11.6516 11.0469C11.8543 10.8442 11.9683 10.5692 11.9683 10.2824V9.74181C11.9683 9.59844 11.9113 9.46093 11.8099 9.35955C11.7085 9.25817 11.571 9.20121 11.4277 9.20121H6.02165C5.87827 9.20121 5.74077 9.25817 5.63939 9.35955C5.53801 9.46093 5.48105 9.59844 5.48105 9.74181V10.2824C5.48105 10.5692 5.36714 10.8442 5.16437 11.0469C4.96161 11.2497 4.6866 11.3636 4.39985 11.3636ZM4.39985 11.3636C4.1131 11.3636 3.83809 11.2497 3.63533 11.0469C3.43256 10.8442 3.31865 10.5692 3.31865 10.2824V2.71401C3.31865 2.42726 3.20474 2.15225 3.00197 1.94949C2.79921 1.74672 2.5242 1.63281 2.23745 1.63281C1.9507 1.63281 1.67569 1.74672 1.47293 1.94949C1.27016 2.15225 1.15625 2.42726 1.15625 2.71401V3.79521C1.15625 3.93859 1.21321 4.07609 1.31459 4.17747C1.41597 4.27886 1.55347 4.33581 1.69685 4.33581H3.31865",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4H5",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6H5",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50241_23394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5625 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceNo);
export default __webpack_public_path__ + "static/media/invoiceNo.1ea14d4408d6d4b669c25329f49c22ed.svg";
export { ForwardRef as ReactComponent };